import React, { useCallback } from "react"
import {
    Text,
    View,
    StyleSheet,
    ScrollView,
    Image,
} from "react-native"

import { AuthContext } from '../../contexts/auth/Store';
import { Currency } from '../../constants/Utils';
import { AnalyticsService } from "../../constants/Analytics";

import OrderGroupCard from "../../components/order/OrderGroupCard";
import OrderGroupOrderCard from "../../components/order/OrderGroupOrderCard";
import moment from "moment";
import FontStyles from "../../constants/FontStyle";
import StyledButton from "../../components/StyledButton";
import Colors from "../../constants/Colors";
import { useFocusEffect, useNavigation, useRoute } from "@react-navigation/native";
import OrderRatingModal from "../../components/modals/OrderRatingModal";
import { OrderContext } from "../../contexts/order/Store";
import DeliverySummary from "../../components/common/DeliverySummary";
import GenericHeader from "../../components/headers/GenericHeader";

const analytics = new AnalyticsService()

function OrderSingleScreen() {
    const navigation = useNavigation()
    const route = useRoute()
    const { state: order_state } = React.useContext(OrderContext)

    const [orderGroup, setOrderGroup] = React.useState(null)
    const [orders, setOrders] = React.useState([])

    const [isConfirmModalOpen, setConfirmModalOpen] = React.useState(false)

    const hideConfirmModal = () => {
        setConfirmModalOpen(false)
    }
    const openConfirmModal = () => {
        setConfirmModalOpen(true)
    }

    const isOrderEditable = (_order) => {
        if (orderGroup.tag !== 'pending') {
            return false
        }

        let date = moment.unix(_order.created),
            end_date = moment(date).add(3, 'hours')

        if (moment().isBefore(end_date)) {
            return true
        }

        return false
    }

    const initialize = () => {
        if (route.params && route.params?.order_id !== null && order_state?.order_group?.length) {
            let _order = order_state.order_group.find((x: any) => x._id === route.params?.order_id)
            if (_order) {
                setOrderGroup(_order)
                setOrders(_order.orders.list)
                navigation.setOptions({
                    title: `Order #${_order.ref}`
                })
            } else {
                console.log('Order group not found.')
            }
        } else {
            console.log('Cannot read order group details.')
        }
    }

    useFocusEffect(
        useCallback(() => {
            if (route.name === 'OrderSingle') {
                if (route.params && route.params.order_id !== null) {
                    initialize()
                } else {
                    navigation.navigate('OrderList')
                }

            } else {
                navigation.navigate('OrderList')
            }
            return () => {
                setOrderGroup(null)
            }
        }, [order_state])
    )

    return (
        <>
            {
                isConfirmModalOpen
                    ? <OrderRatingModal
                        modalState={isConfirmModalOpen}
                        hideModal={hideConfirmModal}
                        order={orderGroup}
                    />
                    : null
            }

            <GenericHeader
                title={`Invoice #${orderGroup && orderGroup.ref}`}
                backAction={() => {
                    navigation.navigate('OrderList')
                }}
            />

            {
                orderGroup
                    ? <ScrollView
                        contentContainerStyle={styles.container}
                    >
                        <OrderGroupCard
                            navigation={navigation}
                            order={orderGroup}
                            readOnly={true}
                            callRep={true}
                            showAddress
                            confirmAction={openConfirmModal}
                        />
                        {
                            orders && orders.length
                                ? <>
                                    {
                                        orders.map(order => <OrderGroupOrderCard key={order._id} order={order} orderGroup={orderGroup} canUpdate={isOrderEditable(order)} />)
                                    }
                                </>
                                : null
                        }
                        <View style={styles.deliverySummaryContainer}>
                            <DeliverySummary
                                isCart={false}
                                order_group={orderGroup}
                            />
                        </View>

                    </ScrollView>
                    : <ScrollView contentContainerStyle={styles.emptyContainer}>
                        <Image source={require('../../assets/images/main/folder-grey.png')} style={styles.emptyImage} />
                        <Text style={styles.emptyText}>Order details currently not available.</Text>
                        <StyledButton
                            label="View Orders"
                            action={() => {
                                navigation.navigate('OrderList')
                            }}
                            style={{
                                marginTop: 32,
                                width: 'auto',
                            }}
                        />
                    </ScrollView>
            }
        </>

    )
}

const styles = StyleSheet.create({
    container: {
        flexGrow: 1,
        justifyContent: 'flex-start',
        backgroundColor: Colors.shades._5,
    },
    deliverySummaryContainer: {
        backgroundColor: Colors.whiteColor,
        marginTop: 6,
        paddingBottom: 20,
    },
    emptyContainer: {
        flexGrow: 1,
        justifyContent: 'center',
        alignItems: 'center',
        paddingHorizontal: 16,
        backgroundColor: Colors.whiteColor,
    },
    emptyImage: {
        width: 50,
        height: 40
    },
    emptyText: {
        maxWidth: 215,
        ...FontStyles.normal,
        ...FontStyles.size14,
        ...FontStyles.lh20,
        ...FontStyles.gray,
        textAlign: 'center',
        marginTop: 18,
    }
})

export default OrderSingleScreen